import { GRAVURE_FACET_ITEM } from "~/components/blocks/vod/list/const/search-facets";
import { CATEGORIES } from "~/const/categories";
import { OTHER_LINK } from "~/const/links";
import { PATHS } from "~/const/paths";
const addNewLine = (name: string) => {
  switch (name) {
    case "DMM TVオリジナル":
      return `DMM TV\nオリジナル`;
    case "DMM TVスペシャル 無料配信":
      return `DMM TVスペシャル\n無料配信`;
    default:
      return name;
  }
};

export const VIDEO_MENUS = [
  ...CATEGORIES.flatMap((item) =>
    item.id !== GRAVURE_FACET_ITEM.value
      ? {
          name: addNewLine(item.name),
          pathname: PATHS.VOD,
          query: {
            id: item.queryParam,
          },
        }
      : []
  ),
  {
    name: OTHER_LINK.name,
    pathname: PATHS.VOD,
    query: {
      id: "other",
    },
  },
];
